export const PRODUCT_ID = {
    AUTO: 'AUTO',
    BROM: 'BROM',
    REIS: 'REIS',
    FIET: 'FIET',
    WOON: 'WOON',
    MOTR: 'MOTR',
    RB: 'RB',
    DIER: 'DIER',
    CVAN: 'CVAN',
    ONGV: 'ONGV',
    AANS: 'AANS',
};

type ValueOf<T> = T[keyof T];

export type ValueOfProductId = ValueOf<typeof PRODUCT_ID>;
